import { render, staticRenderFns } from "./PickupLocationForm.vue?vue&type=template&id=67bd16c2&scoped=true"
import script from "./PickupLocationForm.vue?vue&type=script&lang=js"
export * from "./PickupLocationForm.vue?vue&type=script&lang=js"
import style0 from "./PickupLocationForm.vue?vue&type=style&index=0&id=67bd16c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bd16c2",
  null
  
)

export default component.exports